import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldSchemesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-delete',
	path: '/secure/admin/ViewDeleteFieldScreenScheme.jspa',
};
